import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["video", "playOverlay", "muteIcon", "unmuteIcon"];

  connect() {
    this.isMuted = true;

    // threshold 0.6: play when 60% of the card is visible
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.6,
    });

    if (this.hasVideoTarget) {
      this.observer.observe(this.videoTarget);
    }
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (!this.hasVideoTarget) return;

      if (entry.isIntersecting) {
        this.videoTarget
          .play()
          .catch((err) => console.log("Autoplay blocked:", err));
        this.playOverlayTarget.classList.add("hidden");
      } else {
        this.videoTarget.pause();
        this.playOverlayTarget.classList.remove("hidden");
      }
    });
  }

  toggleMute(e) {
    e.preventDefault();
    e.stopPropagation();

    this.isMuted = !this.isMuted;
    this.videoTarget.muted = this.isMuted;

    // Toggle the icons
    this.muteIconTarget.classList.toggle("hidden", !this.isMuted);
    this.unmuteIconTarget.classList.toggle("hidden", this.isMuted);
  }
}
